"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uid = _interopRequireDefault(require("../../../utils/uid"));

var _ImplicitFileInput = _interopRequireDefault(require("./core/ImplicitFileInput"));

require("./Upload.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Upload = function Upload(_ref) {
  var children = _ref.children,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, ["children", "id"]);

  var uIdUpload = id || (0, _uid.default)('file-input');

  var labelClick = function labelClick(e) {
    if (e.target !== e.currentTarget) e.currentTarget.click();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Upload"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: uIdUpload,
    onClick: labelClick
  }, children)), /*#__PURE__*/_react.default.createElement(_ImplicitFileInput.default, _extends({}, props, {
    id: uIdUpload
  })));
};

Upload.propTypes = {
  children: _propTypes.default.node,
  id: _propTypes.default.string
};
Upload.defaultProps = {
  children: null,
  id: null
};
var _default = Upload;
exports.default = _default;